// import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Navigate, Route } from 'react-router-dom';
// material
// import { Box } from '@mui/material';
// ----------------------------------------------------------------------

// Logo.propTypes = {
//   sx: PropTypes.object
// };

export default function PrivateRoute({ element }) {
  const isLoggedIn = useSelector(state => state.userInfo.isLoggedIn);
  // console.log(isLoggedIn);

  return isLoggedIn ? element : <Navigate to="/login" />;
  // return <Route element={isLoggedIn ? element : <Navigate to="/login" />} />;
}
